import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, unref as _unref, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "mt-5 pt-5 ps-3"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-10 col-md-12 mx-auto" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-6 mb-3" }
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_19 = { class: "col-md-6 mb-3" }
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-4 mb-3" }
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_30 = { class: "col-md-4 mb-3" }
const _hoisted_31 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_32 = { class: "col-md-4 mb-3" }
const _hoisted_33 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "form-check" }
const _hoisted_38 = ["id", "value"]
const _hoisted_39 = ["for"]
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = { class: "mb-4" }
const _hoisted_42 = {
  class: "nav nav-tabs mb-3",
  id: "metaTabs",
  role: "tablist"
}
const _hoisted_43 = ["id", "onClick"]
const _hoisted_44 = {
  class: "tab-content border rounded p-3",
  style: {"max-height":"300px","overflow-y":"auto","background-color":"#f8f9fa"}
}
const _hoisted_45 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_46 = {
  key: 1,
  class: "text-center py-3 text-muted"
}
const _hoisted_47 = {
  key: 2,
  class: "row g-2"
}
const _hoisted_48 = { class: "form-check" }
const _hoisted_49 = ["id", "value"]
const _hoisted_50 = ["for"]
const _hoisted_51 = { class: "mb-4" }
const _hoisted_52 = { class: "form-check form-switch px-0" }
const _hoisted_53 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_54 = { class: "d-flex gap-2 justify-content-end" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }

import { ref, reactive, computed, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import apiService from "@/services/apiService";
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";

// Router
type MetaKey =
  | "capabilities"
  | "roles"
  | "competencies"
  | "rules"
  | "skills"
  | "levels";

// Available tools

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentForm',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// Computed
const isEditMode = computed(() => !!route.params.id);
const agentId = computed(() => route.params.id as string);

const availableTools = ref([
  { value: "web_search", label: "Web Search" },
  { value: "calculator", label: "Calculator" },
  { value: "code_interpreter", label: "Code Interpreter" },
  { value: "image_generation", label: "Image Generation" },
  { value: "file_upload", label: "File Upload" },
  { value: "knowledge_base", label: "Knowledge Base" },
]);

// Knowledge bases
const knowledgeBases = ref<any[]>([]);

// Reactive data
const formData = reactive({
  name: "",
  slug: "",
  description: "",
  systemPrompt: "",
  model: "",
  temperature: 0.7,
  maxOutputTokens: 2000,
  toolsAllowed: [] as string[],
  knowledgeBaseIds: [] as string[],
  isActive: true,
  capabilities: [] as string[],
  roles: [] as string[],
  competencies: [] as string[],
  rules: [] as string[],
  skills: [] as string[],
  levels: [] as string[],
});

const metaTabs: { id: MetaKey; label: string }[] = [
  { id: "capabilities", label: "Capabilities" },
  { id: "roles", label: "Roles" },
  { id: "competencies", label: "Competencies" },
  { id: "rules", label: "Rules" },
  { id: "skills", label: "Skills" },
  { id: "levels", label: "Levels" },
];

const metaOptions = reactive<Record<MetaKey, any[]>>({
  capabilities: [],
  roles: [],
  competencies: [],
  rules: [],
  skills: [],
  levels: [],
});

const activeTab = ref<MetaKey>("capabilities");
const isMetaLoading = ref(false);

const errors = reactive<Record<string, string>>({});
const isLoading = ref(false);
const isSaving = ref(false);
const submitError = ref<string | null>(null);

// Track if slug was manually edited
const slugManuallyEdited = ref(false);

// Methods
const generateSlug = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // Remove special characters
    .replace(/[\s_]+/g, "-") // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
};

// Watch name changes to auto-generate slug (only when creating new agent)
watch(
  () => formData.name,
  (newName) => {
    // Only auto-generate slug if not in edit mode and slug hasn't been manually edited
    if (!isEditMode.value && !slugManuallyEdited.value) {
      formData.slug = generateSlug(newName);
    }
  }
);

// Watch slug changes to detect manual edits
watch(
  () => formData.slug,
  (newSlug, oldSlug) => {
    // If slug is manually changed (not empty and different from auto-generated)
    if (newSlug && oldSlug !== undefined) {
      const autoSlug = generateSlug(formData.name);
      if (newSlug !== autoSlug) {
        slugManuallyEdited.value = true;
      }
    }
  }
);

const loadKnowledgeBases = async () => {
  try {
    const response = await apiService.getKnowledgeBases({ isActive: true });
    if (response) {
      knowledgeBases.value = response.data || response.knowledgeBases || [];
    }
  } catch (err: any) {
    console.error("Error loading knowledge bases:", err);
  }
};

const loadAgent = async () => {
  if (!isEditMode.value) return;

  isLoading.value = true;
  try {
    const response = await apiService.getAgentById(agentId.value);

    // Populate form with existing data
    if (response) {
      formData.name = response.name || "";
      formData.slug = response.slug || "";
      formData.description = response.description || "";
      formData.systemPrompt =
        response.system_prompt || response.systemPrompt || "";
      formData.model = response.model || "";
      formData.temperature = response.temperature ?? 0.7;
      formData.maxOutputTokens =
        response.max_output_tokens ?? response.maxOutputTokens ?? 2000;
      formData.toolsAllowed =
        response.tools_allowed || response.toolsAllowed || [];
      formData.knowledgeBaseIds = (response.knowledge_base_ids || response.knowledgeBaseIds || []).map((id: string) => {
        const kb = knowledgeBases.value.find(k => (k._id || k.id) === id);
        return kb || id;
      });
      formData.isActive = response.is_active ?? response.isActive ?? true;
      formData.capabilities = response.capabilities || [];
      formData.roles = response.roles || [];
      formData.competencies = response.competencies || [];
      formData.rules = response.rules || [];
      formData.skills = response.skills || [];
      formData.levels = response.levels || [];
    }
  } catch (err: any) {
    console.error("Error loading agent:", err);
    showToast(err?.response?.data?.message || "Failed to load agent", "error");
    router.push("/admin/agents");
    } finally {
    isLoading.value = false;
  }
};

const fetchMetaOptions = async () => {
  isMetaLoading.value = true;
  try {
    const [
      capabilities,
      roles,
      competencies,
      rules,
      skills,
      levels,
    ] = await Promise.all([
      apiService.getAgentCapabilities(),
      apiService.getAgentRoles(),
      apiService.getAgentCompetencies(),
      apiService.getAgentRules(),
      apiService.getAgentSkills(),
      apiService.getAgentLevels(),
    ]);

    metaOptions.capabilities = capabilities?.data || capabilities || [];
    metaOptions.roles = roles?.data || roles || [];
    metaOptions.competencies = competencies?.data || competencies || [];
    metaOptions.rules = rules?.data || rules || [];
    metaOptions.skills = skills?.data || skills || [];
    metaOptions.levels = levels?.data || levels || [];
  } catch (err) {
    console.error("Error fetching meta options:", err);
  } finally {
    isMetaLoading.value = false;
  }
};

const validateForm = (): boolean => {
  // Clear previous errors
  Object.keys(errors).forEach((key) => delete errors[key]);

  let isValid = true;

  // Validate name
  if (!formData.name.trim()) {
    errors.name = "Name is required";
    isValid = false;
  } else if (formData.name.length < 3) {
    errors.name = "Name must be at least 3 characters";
    isValid = false;
  }

  // Validate slug
  if (!formData.slug.trim()) {
    errors.slug = "Slug is required";
    isValid = false;
  } else if (!/^[a-z0-9-]+$/.test(formData.slug)) {
    errors.slug =
      "Slug must contain only lowercase letters, numbers, and hyphens";
    isValid = false;
  }

  // Validate system prompt
  if (!formData.systemPrompt || !formData.systemPrompt.trim()) {
    errors.systemPrompt = "System prompt is required";
    isValid = false;
  } else if (formData.systemPrompt.trim().length < 10) {
    errors.systemPrompt = "System prompt must be at least 10 characters";
    isValid = false;
  }

  // Validate model
  if (!formData.model) {
    errors.model = "Model is required";
    isValid = false;
  }

  // Validate temperature
  if (formData.temperature < 0 || formData.temperature > 2) {
    errors.temperature = "Temperature must be between 0 and 2";
    isValid = false;
  }

  // Validate maxOutputTokens
  if (
    formData.maxOutputTokens &&
    (formData.maxOutputTokens < 1 || formData.maxOutputTokens > 4096)
  ) {
    errors.maxOutputTokens = "Max output tokens must be between 1 and 4096";
    isValid = false;
  }

  return isValid;
};

const handleSubmit = async () => {
  submitError.value = null;

  // Validate form
  if (!validateForm()) {
    return;
  }

  isSaving.value = true;

  try {
    const payload = {
      name: formData.name.trim(),
      slug: formData.slug.trim(),
      description: formData.description.trim() || undefined,
      system_prompt: formData.systemPrompt.trim(),
      model: formData.model,
      temperature: formData.temperature,
      max_output_tokens: formData.maxOutputTokens,
      tools_allowed: formData.toolsAllowed,
      knowledge_base_ids: formData.knowledgeBaseIds.map((kb: any) => typeof kb === 'object' ? (kb._id || kb.id) : kb),
      is_active: formData.isActive,
      capabilities: formData.capabilities,
      roles: formData.roles,
      competencies: formData.competencies,
      rules: formData.rules,
      skills: formData.skills,
      levels: formData.levels,
    };

    // Debug logging
    console.log("Submitting agent payload:", payload);
    console.log("System prompt length:", payload.system_prompt.length);

    if (isEditMode.value) {
      // Update existing agent
      await apiService.updateAgent(agentId.value, payload);
      showToast("Agent updated successfully", "success");
      router.push(`/admin/agents/${agentId.value}`);
    } else {
      // Create new agent
      const response = await apiService.createAgent(payload);
      showToast("Agent created successfully", "success");

      // Redirect to the new agent details page
      if (response._id || response.id) {
        router.push(`/admin/agents/${response._id || response.id}`);
      } else {
        router.push("/admin/agents");
      }
    }
  } catch (err: any) {
    console.error("Error saving agent:", err);
    const errorMessage =
      err?.response?.data?.message || err?.message || "Failed to save agent";
    submitError.value = errorMessage;
    showToast(errorMessage, "error");
  } finally {
    isSaving.value = false;
  }
};

const showToast = (message: string, type: "success" | "error" | "info") => {
  console.log(`[${type.toUpperCase()}] ${message}`);
  // Integrate with your toast library here
};

// Lifecycle
onMounted(() => {
  loadKnowledgeBases();
  fetchMetaOptions();
  if (isEditMode.value) {
    loadAgent();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/admin/agents" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Agents", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, _toDisplayString(isEditMode.value ? "Edit" : "New"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h5", _hoisted_11, _toDisplayString(isEditMode.value ? "Edit Agent" : "Create Agent"), 1),
              _createElementVNode("small", _hoisted_12, _toDisplayString(isEditMode.value
                    ? "Update agent configuration and settings"
                    : "Create a new AI agent with custom configuration"), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("div", {
                      class: "spinner-border loading-spinner text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1),
                    _createElementVNode("p", { class: "mt-2" }, "Loading agent...", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _withModifiers(handleSubmit, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[18] || (_cache[18] = _createElementVNode("h6", { class: "text-primary mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-info-circle me-2" }),
                        _createTextVNode("Basic Information ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", {
                            for: "name",
                            class: "form-label"
                          }, [
                            _createTextVNode(" Name "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["form-control", { 'is-invalid': errors.name }]),
                            id: "name",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
                            placeholder: "e.g., Customer Support Agent",
                            required: ""
                          }, null, 2), [
                            [_vModelText, formData.name]
                          ]),
                          (errors.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(errors.name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[15] || (_cache[15] = _createElementVNode("label", {
                            for: "slug",
                            class: "form-label"
                          }, [
                            _createTextVNode(" Slug "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["form-control", { 'is-invalid': errors.slug }]),
                            id: "slug",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.slug) = $event)),
                            placeholder: "e.g., customer-support",
                            required: ""
                          }, null, 2), [
                            [_vModelText, formData.slug]
                          ]),
                          (errors.slug)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(errors.slug), 1))
                            : _createCommentVNode("", true),
                          _cache[16] || (_cache[16] = _createElementVNode("small", { class: "form-text text-muted" }, " Unique identifier (lowercase, hyphens allowed) ", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", {
                          for: "description",
                          class: "form-label"
                        }, " Description ", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          class: _normalizeClass(["form-control", { 'is-invalid': errors.description }]),
                          id: "description",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.description) = $event)),
                          rows: "3",
                          placeholder: "Describe the agent's purpose and capabilities"
                        }, null, 2), [
                          [_vModelText, formData.description]
                        ]),
                        (errors.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(errors.description), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[21] || (_cache[21] = _createElementVNode("h6", { class: "text-primary mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-code me-2" }),
                        _createTextVNode("System Prompt ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", {
                          for: "systemPrompt",
                          class: "form-label"
                        }, [
                          _createTextVNode(" System Prompt "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          class: _normalizeClass(["form-control font-monospace", { 'is-invalid': errors.systemPrompt }]),
                          id: "systemPrompt",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.systemPrompt) = $event)),
                          rows: "8",
                          placeholder: "You are a helpful assistant that...",
                          required: ""
                        }, null, 2), [
                          [_vModelText, formData.systemPrompt]
                        ]),
                        (errors.systemPrompt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(errors.systemPrompt), 1))
                          : _createCommentVNode("", true),
                        _cache[20] || (_cache[20] = _createElementVNode("small", { class: "form-text text-muted" }, " Define the agent's behavior, personality, and instructions ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[27] || (_cache[27] = _createElementVNode("h6", { class: "text-primary mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-cog me-2" }),
                        _createTextVNode("Model Configuration ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", {
                            for: "model",
                            class: "form-label"
                          }, [
                            _createTextVNode(" Model "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-select", { 'is-invalid': errors.model }]),
                            id: "model",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.model) = $event)),
                            required: ""
                          }, [...(_cache[22] || (_cache[22] = [
                            _createStaticVNode("<option value=\"\" data-v-0d6b7a2c>Select Model</option><option value=\"gpt-4\" data-v-0d6b7a2c>GPT-4</option><option value=\"gpt-4-turbo\" data-v-0d6b7a2c>GPT-4 Turbo</option><option value=\"gpt-3.5-turbo\" data-v-0d6b7a2c>GPT-3.5 Turbo</option><option value=\"claude-3-opus\" data-v-0d6b7a2c>Claude 3 Opus</option><option value=\"claude-3-sonnet\" data-v-0d6b7a2c>Claude 3 Sonnet</option><option value=\"claude-3-haiku\" data-v-0d6b7a2c>Claude 3 Haiku</option>", 7)
                          ]))], 2), [
                            [_vModelSelect, formData.model]
                          ]),
                          (errors.model)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(errors.model), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", {
                            for: "temperature",
                            class: "form-label"
                          }, " Temperature ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: _normalizeClass(["form-control", { 'is-invalid': errors.temperature }]),
                            id: "temperature",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.temperature) = $event)),
                            min: "0",
                            max: "2",
                            step: "0.1",
                            placeholder: "0.7"
                          }, null, 2), [
                            [
                              _vModelText,
                              formData.temperature,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          (errors.temperature)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(errors.temperature), 1))
                            : _createCommentVNode("", true),
                          _cache[25] || (_cache[25] = _createElementVNode("small", { class: "form-text text-muted" }, " 0 = deterministic, 2 = creative ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _cache[26] || (_cache[26] = _createElementVNode("label", {
                            for: "maxOutputTokens",
                            class: "form-label"
                          }, " Max Output Tokens ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: _normalizeClass(["form-control", { 'is-invalid': errors.maxOutputTokens }]),
                            id: "maxOutputTokens",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.maxOutputTokens) = $event)),
                            min: "1",
                            max: "4096",
                            placeholder: "2000"
                          }, null, 2), [
                            [
                              _vModelText,
                              formData.maxOutputTokens,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          (errors.maxOutputTokens)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(errors.maxOutputTokens), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[33] || (_cache[33] = _createElementVNode("h6", { class: "text-primary mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-wrench me-2" }),
                        _createTextVNode("Tools & Capabilities ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_35, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label" }, "Tools Allowed", -1)),
                        _createElementVNode("div", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTools.value, (tool) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: tool.value,
                              class: "col-md-4 mb-2"
                            }, [
                              _createElementVNode("div", _hoisted_37, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: `tool-${tool.value}`,
                                  value: tool.value,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.toolsAllowed) = $event))
                                }, null, 8, _hoisted_38), [
                                  [_vModelCheckbox, formData.toolsAllowed]
                                ]),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: `tool-${tool.value}`
                                }, _toDisplayString(tool.label), 9, _hoisted_39)
                              ])
                            ]))
                          }), 128))
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("small", { class: "form-text text-muted" }, " Select which tools this agent can use ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _cache[31] || (_cache[31] = _createElementVNode("label", {
                          for: "knowledgeBaseIds",
                          class: "form-label fw-bold"
                        }, " Knowledge Bases ", -1)),
                        _createVNode(_unref(VueMultiselect), {
                          modelValue: formData.knowledgeBaseIds,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.knowledgeBaseIds) = $event)),
                          options: knowledgeBases.value,
                          multiple: true,
                          "close-on-select": false,
                          "clear-on-select": false,
                          "preserve-search": true,
                          placeholder: "Select Knowledge Bases",
                          label: "name",
                          "track-by": "_id",
                          "preselect-first": false
                        }, {
                          noResult: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createElementVNode("span", null, "No knowledge bases found.", -1)
                          ]))]),
                          _: 1
                        }, 8, ["modelValue", "options"]),
                        _cache[32] || (_cache[32] = _createElementVNode("small", { class: "form-text text-muted mt-1 d-block" }, " Select one or more knowledge bases for this agent ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "text-primary mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-tags me-2" }),
                        _createTextVNode("Agent Meta Information ")
                      ], -1)),
                      _createElementVNode("ul", _hoisted_42, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(metaTabs, (tab) => {
                          return _createElementVNode("li", {
                            class: "nav-item",
                            role: "presentation",
                            key: tab.id
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["nav-link text-capitalize", { active: activeTab.value === tab.id }]),
                              id: tab.id + '-tab',
                              type: "button",
                              role: "tab",
                              onClick: ($event: any) => (activeTab.value = tab.id)
                            }, _toDisplayString(tab.label), 11, _hoisted_43)
                          ])
                        }), 64))
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        (isMetaLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [...(_cache[34] || (_cache[34] = [
                              _createElementVNode("div", {
                                class: "spinner-border loading-spinner text-primary",
                                role: "status"
                              }, null, -1),
                              _createElementVNode("span", { class: "ms-2 small" }, "Loading options...", -1)
                            ]))]))
                          : (metaOptions[activeTab.value].length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, " No options available for " + _toDisplayString(activeTab.value), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metaOptions[activeTab.value], (option) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: option._id || option.id || option,
                                    class: "col-md-4 col-sm-6"
                                  }, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: option._id || option.id || option,
                                        value: option.title || option.name || option.label || option,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData[activeTab.value]) = $event))
                                      }, null, 8, _hoisted_49), [
                                        [_vModelCheckbox, formData[activeTab.value]]
                                      ]),
                                      _createElementVNode("label", {
                                        class: "form-check-label small",
                                        for: option._id || option.id || option
                                      }, _toDisplayString(option.title || option.name || option.label || option), 9, _hoisted_50)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                      ]),
                      _cache[36] || (_cache[36] = _createElementVNode("small", { class: "form-text text-muted mt-2 d-block" }, " Select multiple options relevant to this agent ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _cache[38] || (_cache[38] = _createElementVNode("h6", { class: "text-primary mb-3" }, [
                        _createElementVNode("i", { class: "fa fa-toggle-on me-2" }),
                        _createTextVNode("Status ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_52, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input ms-1",
                          type: "checkbox",
                          id: "isActive",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.isActive) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, formData.isActive]
                        ]),
                        _cache[37] || (_cache[37] = _createElementVNode("label", {
                          class: "form-check-label ps-2",
                          for: "isActive"
                        }, " Active ", -1))
                      ]),
                      _cache[39] || (_cache[39] = _createElementVNode("small", { class: "form-text text-muted" }, " Only active agents can be used in conversations ", -1))
                    ]),
                    (submitError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(submitError.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_router_link, {
                        to: "/admin/agents",
                        class: "btn btn-outline-secondary"
                      }, {
                        default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                          _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                          _createTextVNode(" Cancel ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary",
                        disabled: isSaving.value
                      }, [
                        (isSaving.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, [...(_cache[42] || (_cache[42] = [
                              _createElementVNode("span", {
                                class: "spinner-border spinner-border-sm me-1",
                                role: "status"
                              }, null, -1),
                              _createTextVNode(" Saving... ", -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_57, [
                              _cache[43] || (_cache[43] = _createElementVNode("i", { class: "fa fa-save me-1" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(isEditMode.value ? "Update" : "Create"), 1)
                            ]))
                      ], 8, _hoisted_55)
                    ])
                  ], 32))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})